import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import ReactGA from "react-ga";

const styles = {
  root: {
    textAlign: "center"
  },
  button: {
    margin: "10px"
  }
};

class YesNo extends Component {
  handleNo = () => {
    const { title } = this.props;
    ReactGA.event({
      category: "Route",
      action: "Answer No",
      label: title
    });
    const { callback, setKey } = this.props;
    callback(setKey, false);
  };

  handleYes = () => {
    const { title } = this.props;
    ReactGA.event({
      category: "Route",
      action: "Answer Yes",
      label: title
    });
    const { callback, setKey } = this.props;
    callback(setKey, true);
  };

  handleSkip = () => {
    const { title } = this.props;
    ReactGA.event({
      category: "Route",
      action: "Skip question",
      label: title
    });
    const { callback, setKey } = this.props;
    callback(setKey, null);
  };

  render() {
    const { classes, title, mandatory } = this.props;
    return (
      <div className={classes.root}>
        <h1>{title}</h1>
        <Button
          variant="raised"
          color="primary"
          className={classes.button}
          onClick={this.handleNo}
        >
          Nee
        </Button>
        <Button
          variant="raised"
          color="primary"
          className={classes.button}
          onClick={this.handleYes}
        >
          Ja
        </Button>
        {!mandatory && (
          <div>
            <Button
              variant="raised"
              className={classes.button}
              onClick={this.handleSkip}
            >
              Maakt niet uit
            </Button>
          </div>
        )}
      </div>
    );
  }
}

YesNo.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired,
  setKey: PropTypes.string.isRequired,
  mandatory: PropTypes.bool
};

export default withStyles(styles)(YesNo);



// WEBPACK FOOTER //
// ./src/NewRoute/components/YesNo.js